export default __webpack_public_path__ + "static/media/video.edf4fd41.mp4";